var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardDeclined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 102,
    viewBox: "0 0 26 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17A141",
    fillRule: "nonzero",
    d: "M22.663 68.853H3.684L.695 0h24.957l-2.989 68.853zM0 90.305c0-3.414 1.24-6.216 3.72-8.407C6.198 79.706 9.291 78.61 13 78.61c3.708 0 6.801 1.095 9.28 3.287 2.48 2.19 3.72 4.993 3.72 8.407 0 3.414-1.24 6.217-3.72 8.408C19.802 100.904 16.709 102 13 102c-3.708 0-6.801-1.096-9.28-3.287C1.24 96.522 0 93.719 0 90.305z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDeclined);
export default __webpack_public_path__ + "static/media/card-declined.453f801e.svg";
export { ForwardRef as ReactComponent };